import type { IcIcon } from "./types";

export const IcBullet: IcIcon = (properties) => (
  <svg
    viewBox="0 0 6 6"
    width={6}
    xmlns="http://www.w3.org/2000/svg"
    {...properties}
  >
    <path d="M5 0H1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1Z" />
  </svg>
);
